/**
 * Global Imports
*/

import React, { useContext } from 'react';
import { Formik, Form, Field } from 'formik';

/**
 * Root Imports
*/

import { Input, Submit } from '~/components/Form';
import { CssClassName } from '~/util/Css';

/**
 * Local Imports
*/

import { AuthContext } from './GuestForms';

/**
 * Exports
*/

/**
 * 
 */
export function Login(props) {
  /** Contexts **/

  const auth = useContext(AuthContext);

  /** Formik **/
  
  const initialValues = {
    email: '',
    password: ''
  };
  
  /** Renderers **/
  
  /**
   * 
   */
  const renderForm = ({ isSubmitting, ...formik }) => {
    return (
      <Form>
        <Input
          name='email'
          className='form-input'
          containerClassName='mb-4'
          placeholder='Email'
          hasError={ 'email' in auth.errorFields }
          formik={ formik }
        />

        <Input
          name='password'
          type='password'
          className='form-input'
          containerClassName='mb-4'
          hasError={ 'password' in auth.errorFields }
          placeholder='Password'
          formik={ formik }
        />

        <Submit
          className={
            CssClassName([
              'w-full btn btn-blue', isSubmitting && 'loading'
            ])
          }
          label='Sign In'
          disabled={ isSubmitting }
        />
      </Form>
    );
  };
  
  /** Output **/
  
  return (
    <Formik initialValues={ initialValues } onSubmit={ auth.onLogin }>
      { renderForm }
    </Formik>
  );
}